import React from 'react'
import { CobuStack, CobuText } from '@cobu/ui'
import { Strings } from '../../constants/Strings';

type Props = {
  likesHelpingWith?: string[]
  needsHelpWith?: string[]
}

export default function PublicProfileSkills({ likesHelpingWith, needsHelpWith }: Props) {
  const hasHelpingSkills = (likesHelpingWith || []).some((s) => s.trim() !== '')
  const hasNeedsHelp = (needsHelpWith || []).some((s) => s.trim() !== '')
  const strings = Strings.get();
  if (!hasHelpingSkills && !hasNeedsHelp) return null

  return (
    <CobuStack gap="$0" py="$2" px="$4" bg="$background" br="$3">
      <CobuText variant="subheading" fontWeight="bold" fontSize={'$6' as any} color="$cobuDarkBlue">
        {strings.publicProfile.sections.skills}
      </CobuText>

      {hasHelpingSkills ? (
        <CobuStack gap="$3">
          <CobuText variant="caption" color="$cobuDarkBlue" fontWeight="bold" fontSize={'$1' as any} mt="$2">
            {strings.publicProfile.sections.skillsSubtitle}
          </CobuText>
          <CobuStack gap="$2">
            {(likesHelpingWith || []).map((skill, index) => {
              if (!skill.trim()) return null
              return (
                <CobuStack key={index} layout="horizontal" ai="center" gap="$2">
                  <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden>
                    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" fill="var(--cobuTeal)"/>
                    <path d="M10 14l-2-2 1.4-1.4L10 11.2l4.6-4.6L16 8l-6 6z" fill="var(--white)"/>
                  </svg>
                  <CobuText variant="body" color="$cobuDarkBlue" fontSize={'$2' as any} ml="$2">
                    {skill}
                  </CobuText>
                </CobuStack>
              )
            })}
          </CobuStack>
        </CobuStack>
      ) : null}

      {hasNeedsHelp ? (
        <CobuStack gap="$3">
          <CobuText variant="caption" color="$cobuDarkBlue" fontWeight="bold" fontSize={'$1' as any} mt="$2">
            {strings.publicProfile.sections.needHelp}
          </CobuText>
          <CobuStack gap="$2">
            {(needsHelpWith || []).map((skill, index) => {
              if (!skill.trim()) return null
              return (
                <CobuStack key={index} layout="horizontal" ai="center" gap="$2">
                  <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden>
                    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" fill="var(--cobuPink)"/>
                    <path d="M10 14l-2-2 1.4-1.4L10 11.2l4.6-4.6L16 8l-6 6z" fill="var(--white)"/>
                  </svg>
                  <CobuText variant="body" color="$cobuDarkBlue" fontSize={'$2' as any} ml="$2">
                    {skill}
                  </CobuText>
                </CobuStack>
              )
            })}
          </CobuStack>
        </CobuStack>
      ) : null}
    </CobuStack>
  )
}


